if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // Reset loading state when page is restored from bfcache (browser back from checkout)
        this.pageshowHandler = (event) => {
          if (event.persisted) {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          }
        };
        window.addEventListener('pageshow', this.pageshowHandler);
      }

      disconnectedCallback() {
        window.removeEventListener('pageshow', this.pageshowHandler);
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const variantId = this.variantIdInput.value;
        const formId = this.form.getAttribute('id');
        const quantity =
          this.form.querySelector('[name="quantity"]')?.value ||
          document.querySelector(`[form="${formId}"][name="quantity"]`)?.value ||
          1;

        const qty = parseInt(quantity);
        const quantityInput = this.form.querySelector('[name="quantity"]') ||
          document.querySelector(`[form="${formId}"][name="quantity"]`);
        const isBulk = quantityInput?.dataset?.lastVariantBulk === 'true';
        const noBonus = quantityInput?.dataset?.noBonus === 'true';
        const inventory = parseInt(quantityInput?.dataset?.inventory, 10);
        const actualQuantity = (!noBonus && typeof window.shouldApplyBonus === 'function' && window.shouldApplyBonus(qty, isBulk, inventory)) ? qty + 1 : qty;

        try {
          // 1. Clear cart
          const clearResponse = await fetch('/cart/clear.js', { method: 'POST' });
          if (!clearResponse.ok) {
            this.handleErrorMessage('カートのクリアに失敗しました。');
            this.error = true;
            return;
          }

          // 2. Add current product to cart
          const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: actualQuantity }] }),
          });
          const addData = await addResponse.json();

          if (addData.status) {
            this.handleErrorMessage(addData.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButtonText.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          // 3. Redirect to checkout
          this.error = false;
          window.location.href = '/checkout';
        } catch (e) {
          console.error(e);
          this.handleErrorMessage('ネットワークエラーが発生しました。もう一度お試しください。');
          this.error = true;
        } finally {
          if (this.error) {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          }
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = text || window.variantStrings?.addToCart || '今すぐ購入';
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
